import React from 'react';
import { Navigate } from 'react-router-dom';
import { Option } from 'effect';
import { AccessInput } from '@/abilities/accessInput';

/**
 * Where a container's address leads: the absolute path of its landing leaf, none when nothing under it is open.
 * A hook, created once when the route table loads, like a route condition.
 */
export type RouteLanding = () => AccessInput<Option.Option<string>>;

type FirstOpenChildRedirectProps = {
  landing: RouteLanding;
};

// The index route of a container. It renders nothing while the landing is not known or failed and when nothing is
// open: the container's guard above shows the progress bar and the error, and a container with nothing open never
// reaches here — the settings root is not found, a locked tab shows its stub. Placed under no such guard, it would
// leave an empty screen.
const FirstOpenChildRedirect = ({ landing }: FirstOpenChildRedirectProps) =>
  AccessInput.$match(landing(), {
    Ready: ({ value }) => Option.match(value, { onNone: () => null, onSome: (to) => <Navigate to={to} replace /> }),
    Loading: () => null,
    Failed: () => null,
  });

export default FirstOpenChildRedirect;
